import guestStore from '../bundles/GuestSignUp/store'
import hostStore from '../bundles/HostSignUp/store'
export default window.location.pathname.includes('guests/signup') ? guestStore : hostStore
